import { render } from "./test-banner-skeleton.vue?vue&type=template&id=5d6c22b2&scoped=true"
import script from "./test-banner-skeleton.vue?vue&type=script&lang=js"
export * from "./test-banner-skeleton.vue?vue&type=script&lang=js"

import "./test-banner-skeleton.vue?vue&type=style&index=0&id=5d6c22b2&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6c22b2"]])

export default __exports__